import "../css/Patient.css";

export default function ButtonSectionHeader({ onClick, icon, text }) {
  return (
    <button className="button-section-content" onClick={onClick} tabIndex={-1}>
      <img
        src={icon}
        loading="lazy"
        alt="Icon"
        className="section-header-icon"
      />
      <span>{text}</span>
    </button>
  );
}
